import { createFileRoute } from "@tanstack/react-router";

import { FlowInvestment } from "~/components/feature/flow/components";

export const Route = createFileRoute("/_app/dashboard/flow/investment")({
  component: RouteComponent,
});

function RouteComponent() {
  return <FlowInvestment />;
}
